import { onReady } from "../core/ready";

const PRICING_GROUP_PARAM = "pricing_group";

function getPricingGroupFromUrl() {
	const params = new URLSearchParams(window.location.search);
	return params.get(PRICING_GROUP_PARAM)?.trim() || "";
}

function resolveGroupIdBySlug(groups, slug) {
	if (!slug) return null;

	const group = [...groups].find((item) => item.dataset.groupSlug === slug);
	return group ? group.dataset.groupId : null;
}

function initPricingGroups() {
	const pricingBlocks = document.querySelectorAll(".block-pricing");
	if (!pricingBlocks.length) return;

	const urlGroup = getPricingGroupFromUrl();

	pricingBlocks.forEach((block) => {
		const select = block.querySelector(".js-pricing-group-select");
		const groups = block.querySelectorAll(".js-pricing-group");
		if (!select || !groups.length) return;

		const setActiveGroup = (groupId) => {
			groups.forEach((group) => {
				const isActive = group.dataset.groupId === String(groupId);
				group.hidden = !isActive;
			});
		};

		const initialGroupId = resolveGroupIdBySlug(groups, urlGroup) ?? select.value;

		if (initialGroupId !== select.value) {
			select.value = initialGroupId;
		}

		setActiveGroup(initialGroupId);
		select.addEventListener("change", (event) => {
			setActiveGroup(event.target.value);
		});
	});
}

onReady(initPricingGroups);
